// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__PDizQ","head":"ProcedureTableInfo_head__27Qdk"};